import { SvgIconDefinition } from '@am/icons-common-types';
const width = 128;
const height = 128;
const path = `M60.952,0c-2.154,0-3.907,2.08-3.907,4.628v6.139H15.807v28.415L2.195,64.641c-3.349,6.267-2.804,13.406,1.218,15.875c3.647,2.232,8.943-0.115,12.395-5.235v12.236c0,15.972,11.04,29.039,24.525,29.039c13.492,0,24.525-13.067,24.525-29.039V4.628C64.858,2.08,63.099,0,60.952,0z M63.391,10.767h-4.877V6.041c0-2.542,1.091-4.629,2.439-4.629c1.335,0,2.438,2.087,2.438,4.629V10.767z`;

export const aciKitchenFacilities: SvgIconDefinition = {
  iconName: 'kitchen-facilities',
  iconData: [height, width, path],
};
